import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aade8a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "close"
}
const _hoisted_2 = { class: "card_desc" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "card-page" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "first" }, null, -1))
const _hoisted_7 = { class: "card-item" }
const _hoisted_8 = { class: "close" }
const _hoisted_9 = { class: "card_desc" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "card-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_h_swipe = _resolveComponent("h-swipe")!

  return (_ctx.imagePreviewRef)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "imagePreview",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        (_ctx.mobile)
          ? (_openBlock(), _createBlock(_component_h_swipe, {
              key: 0,
              list: _ctx.pictureWallList,
              showIndicator: false,
              current: _ctx.current,
              class: "card",
              autoplay: false,
              circular: false,
              nextMargin: 10,
              previousMargin: 20
            }, {
              swipeItem: _withCtx(({ item, index, currentIndex }) => [
                _createElementVNode("div", {
                  class: "card-item",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (index === currentIndex)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
                          style: _normalizeStyle({
                  backgroundImage: `url(${_ctx.IconUrl})`,
                  backgroundSize: '100% auto',
                  backgroundRepeat: 'no-repeat',
                })
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true),
                  (item.pop_up_image)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "img",
                        style: _normalizeStyle({
                backgroundImage: `url(${_ctx.imgOptimize(item.pop_up_image)})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              })
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.title_desc), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(index + 1) + " / " + _toDisplayString(_ctx.pictureWallList.length), 1)
              ]),
              _: 1
            }, 8, ["list", "current"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "card vertical-scroll",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pictureWallList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
                        style: _normalizeStyle({
                  backgroundImage: `url(${_ctx.IconUrl})`,
                  backgroundSize: '100% auto',
                  backgroundRepeat: 'no-repeat',
                })
                      }, null, 4)
                    ]),
                    (item.pop_up_image)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "img",
                          style: _normalizeStyle({
                backgroundImage: `url(${_ctx.imgOptimize(item.pop_up_image)})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              })
                        }, null, 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(item.title_desc), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(index + 1) + " / " + _toDisplayString(_ctx.pictureWallList.length), 1)
                ]))
              }), 128))
            ]))
      ]))
    : _createCommentVNode("", true)
}